import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccordionEntry, LazyAccountPromo, LazyAsyncStoryblokComponent, LazyBrame, LazyBrandList, LazyButtonBox, LazyClickableImage, LazyCmsButton, LazyCmsHeadline, LazyCmsImage, LazyCmsLink, LazyCmsSlide, LazyCmsText, LazyCmsVideo, LazyConsentSettings, LazyConsentSettingsLink, LazyContactLensConsultant, LazyContentTriple, LazyCookieList, LazyDesignerDouble, LazyDesignerHighlight, LazyDesignerShifted, LazyDetailImage, LazyFaceScan, LazyFallbackComponent, LazyFooterColumn, LazyGrid, LazyHearingTest, LazyHero, LazyHeroTeaser, LazyIconParagraph, LazyImageDisclaimer, LazyImageParagraph, LazyImageSlider, LazyImageSliderSlide, LazyImageWarning, LazyInfographic, LazyLogoSlider, LazyNdlList, LazyNewsletter, LazyPage, LazyParagraph, LazyPrescriptionLoader, LazyProduct, LazyProductSlider, LazyProductSliderCarousel, LazyProductWrapper, LazyQuestionaire, LazyQuestionaireCollapsible, LazyQuestionaireNoResult, LazyQuestionaireOverlay, LazyQuestionaireResult, LazyQuestionaireStep, LazyRichTextHtmlRenderer, LazyRichTextRenderer, LazyScrollableLinkList, LazyShopableImage, LazySlideShow, LazyStory, LazyStoryblokLink, LazyStylePttrns, LazyTeaser, LazyTeaserCard, LazyVideoEmbed, LazyVimeo, LazyYoutube, LazyLayoutContentPage, LazyProductSubscription, LazyProductSubscriptionHeader, LazyProductSubscriptionSavingInfo, LazyProductSubscriptionSelection, LazyIconColorBeige, LazyIconColorBlau, LazyIconColorBraun, LazyIconColorBronze, LazyIconColorBunt, LazyIconColorGelb, LazyIconColorGold, LazyIconColorGoldfarben, LazyIconColorGrau, LazyIconColorGruen, LazyIconColorGrun, LazyIconColorHavanna, LazyIconColorKristallTransparent, LazyIconColorKupfer, LazyIconColorLensBrown, LazyIconColorLensGreen, LazyIconColorLensGrey, LazyIconColorLila, LazyIconColorOrange, LazyIconColorPink, LazyIconColorRosa, LazyIconColorRot, LazyIconColorSchwarz, LazyIconColorSilber, LazyIconColorSilberfarben, LazyIconColorTransparent, LazyIconColorViolett, LazyIconColorWeiss, LazyIconFaceShapeEckig, LazyIconFaceShapeHerz, LazyIconFaceShapeOval, LazyIconFaceShapeRund, LazyIconFaceShapeTrapez, LazyIconFielmannAbo, LazyIconFielmannArrowDoubleLeft, LazyIconFielmannArrowDoubleRight, LazyIconFielmannArrowDown, LazyIconFielmannArrowLeft, LazyIconFielmannArrowRight, LazyIconFielmannArrowUp, LazyIconFielmannBook, LazyIconFielmannBox, LazyIconFielmannBrokenHeart, LazyIconFielmannBurger, LazyIconFielmannCalendar, LazyIconFielmannCameraBordered, LazyIconFielmannCancel, LazyIconFielmannCart, LazyIconFielmannCheck, LazyIconFielmannCheckCircle, LazyIconFielmannCheckHalfcircle, LazyIconFielmannChevronDown, LazyIconFielmannChevronLeft, LazyIconFielmannChevronRight, LazyIconFielmannChevronUp, LazyIconFielmannCircleCross, LazyIconFielmannClipboard, LazyIconFielmannClock, LazyIconFielmannClose, LazyIconFielmannCompass, LazyIconFielmannComputer, LazyIconFielmannContactLens, LazyIconFielmannDelivery, LazyIconFielmannDelivery2, LazyIconFielmannDownload, LazyIconFielmannDuration, LazyIconFielmannEdit, LazyIconFielmannEmojiSad, LazyIconFielmannEye, LazyIconFielmannEyeTest, LazyIconFielmannEyeTestMultifocal, LazyIconFielmannFavoriteActive, LazyIconFielmannFavoriteInactive, LazyIconFielmannFilter, LazyIconFielmannFrame, LazyIconFielmannFrameVarifocals, LazyIconFielmannGift, LazyIconFielmannGlass, LazyIconFielmannGlasses, LazyIconFielmannGlassesSimilar, LazyIconFielmannGlassesSingleVision, LazyIconFielmannGlassesWidth, LazyIconFielmannHearingAid, LazyIconFielmannHistory, LazyIconFielmannHome, LazyIconFielmannInfoCircle, LazyIconFielmannInvoice, LazyIconFielmannLock, LazyIconFielmannLogin, LazyIconFielmannLogo, LazyIconFielmannLogoCZ, LazyIconFielmannLogoPL, LazyIconFielmannLogout, LazyIconFielmannMail, LazyIconFielmannMinus, LazyIconFielmannMore, LazyIconFielmannMoreVertical, LazyIconFielmannNavigate, LazyIconFielmannNotification, LazyIconFielmannOpenInWindow, LazyIconFielmannPause, LazyIconFielmannPencil, LazyIconFielmannPhone, LazyIconFielmannPin, LazyIconFielmannPlay, LazyIconFielmannPlus, LazyIconFielmannQuestionBubble, LazyIconFielmannReload, LazyIconFielmannReloadDouble, LazyIconFielmannReturn, LazyIconFielmannReturnAlt, LazyIconFielmannReturnOrder, LazyIconFielmannScreenshot, LazyIconFielmannSearch, LazyIconFielmannSettings, LazyIconFielmannShoppingBag, LazyIconFielmannSoundHigh, LazyIconFielmannSoundOff, LazyIconFielmannSpeechBubbles, LazyIconFielmannStore, LazyIconFielmannSunglasses, LazyIconFielmannTools, LazyIconFielmannTrash, LazyIconFielmannUpdown, LazyIconFielmannUser, LazyIconFielmannUserCircle, LazyIconFielmannUserVerified, LazyIconFielmannWallet, LazyIconFielmannWarning, LazyIconFielmannWarningHexagon, LazyIconFielmannWebcam, LazyIconFielmannZoomIn, LazyIconFrameShapeAchteckig, LazyIconFrameShapeBrowline, LazyIconFrameShapeButterfly, LazyIconFrameShapeCateye, LazyIconFrameShapeEckig, LazyIconFrameShapeHalb, LazyIconFrameShapeKaree, LazyIconFrameShapeMehreckig, LazyIconFrameShapeMonoscheibe, LazyIconFrameShapeOval, LazyIconFrameShapePanto, LazyIconFrameShapePilot, LazyIconFrameShapeQuadratisch, LazyIconFrameShapeRaute, LazyIconFrameShapeRechteckig, LazyIconFrameShapeRund, LazyIconFrameShapeSchmal, LazyIconFrameShapeSonstige, LazyIconHeadWidthL, LazyIconHeadWidthM, LazyIconHeadWidthS, LazyIconLensqualityCheck, LazyIconLensqualityShield, LazyIconLensqualitySun, LazyIconPaymentBlik, LazyIconPaymentCashOnDelivery, LazyIconPaymentCreditcard, LazyIconPaymentDinersclub, LazyIconPaymentDiscover, LazyIconPaymentKlarna, LazyIconPaymentLastschrift, LazyIconPaymentMastercard, LazyIconPaymentP24, LazyIconPaymentPaypalBw, LazyIconPaymentPaypal, LazyIconPaymentRatepay, LazyIconPaymentRechnung, LazyIconPaymentSofort, LazyIconPaymentTwint, LazyIconPaymentVisa, LazyIconRimTypeGerillt, LazyIconRimTypeHalbrand, LazyIconRimTypeNylor, LazyIconRimTypeRandlos, LazyIconRimTypeVollrand, LazyIconSocialFacebook, LazyIconSocialInstagram, LazyIconSocialPinterest, LazyIconSocialYoutube, LazyIconVtoVerfugbar } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccordionEntry", LazyAccordionEntry],
["AccountPromo", LazyAccountPromo],
["AsyncStoryblokComponent", LazyAsyncStoryblokComponent],
["Brame", LazyBrame],
["BrandList", LazyBrandList],
["ButtonBox", LazyButtonBox],
["ClickableImage", LazyClickableImage],
["CmsButton", LazyCmsButton],
["CmsHeadline", LazyCmsHeadline],
["CmsImage", LazyCmsImage],
["CmsLink", LazyCmsLink],
["CmsSlide", LazyCmsSlide],
["CmsText", LazyCmsText],
["CmsVideo", LazyCmsVideo],
["ConsentSettings", LazyConsentSettings],
["ConsentSettingsLink", LazyConsentSettingsLink],
["ContactLensConsultant", LazyContactLensConsultant],
["ContentTriple", LazyContentTriple],
["CookieList", LazyCookieList],
["DesignerDouble", LazyDesignerDouble],
["DesignerHighlight", LazyDesignerHighlight],
["DesignerShifted", LazyDesignerShifted],
["DetailImage", LazyDetailImage],
["FaceScan", LazyFaceScan],
["FallbackComponent", LazyFallbackComponent],
["FooterColumn", LazyFooterColumn],
["Grid", LazyGrid],
["HearingTest", LazyHearingTest],
["Hero", LazyHero],
["HeroTeaser", LazyHeroTeaser],
["IconParagraph", LazyIconParagraph],
["ImageDisclaimer", LazyImageDisclaimer],
["ImageParagraph", LazyImageParagraph],
["ImageSlider", LazyImageSlider],
["ImageSliderSlide", LazyImageSliderSlide],
["ImageWarning", LazyImageWarning],
["Infographic", LazyInfographic],
["LogoSlider", LazyLogoSlider],
["NdlList", LazyNdlList],
["Newsletter", LazyNewsletter],
["Page", LazyPage],
["Paragraph", LazyParagraph],
["PrescriptionLoader", LazyPrescriptionLoader],
["Product", LazyProduct],
["ProductSlider", LazyProductSlider],
["ProductSliderCarousel", LazyProductSliderCarousel],
["ProductWrapper", LazyProductWrapper],
["Questionaire", LazyQuestionaire],
["QuestionaireCollapsible", LazyQuestionaireCollapsible],
["QuestionaireNoResult", LazyQuestionaireNoResult],
["QuestionaireOverlay", LazyQuestionaireOverlay],
["QuestionaireResult", LazyQuestionaireResult],
["QuestionaireStep", LazyQuestionaireStep],
["RichTextHtmlRenderer", LazyRichTextHtmlRenderer],
["RichTextRenderer", LazyRichTextRenderer],
["ScrollableLinkList", LazyScrollableLinkList],
["ShopableImage", LazyShopableImage],
["SlideShow", LazySlideShow],
["Story", LazyStory],
["StoryblokLink", LazyStoryblokLink],
["StylePttrns", LazyStylePttrns],
["Teaser", LazyTeaser],
["TeaserCard", LazyTeaserCard],
["VideoEmbed", LazyVideoEmbed],
["Vimeo", LazyVimeo],
["Youtube", LazyYoutube],
["LayoutContentPage", LazyLayoutContentPage],
["ProductSubscription", LazyProductSubscription],
["ProductSubscriptionHeader", LazyProductSubscriptionHeader],
["ProductSubscriptionSavingInfo", LazyProductSubscriptionSavingInfo],
["ProductSubscriptionSelection", LazyProductSubscriptionSelection],
["IconColorBeige", LazyIconColorBeige],
["IconColorBlau", LazyIconColorBlau],
["IconColorBraun", LazyIconColorBraun],
["IconColorBronze", LazyIconColorBronze],
["IconColorBunt", LazyIconColorBunt],
["IconColorGelb", LazyIconColorGelb],
["IconColorGold", LazyIconColorGold],
["IconColorGoldfarben", LazyIconColorGoldfarben],
["IconColorGrau", LazyIconColorGrau],
["IconColorGruen", LazyIconColorGruen],
["IconColorGrun", LazyIconColorGrun],
["IconColorHavanna", LazyIconColorHavanna],
["IconColorKristallTransparent", LazyIconColorKristallTransparent],
["IconColorKupfer", LazyIconColorKupfer],
["IconColorLensBrown", LazyIconColorLensBrown],
["IconColorLensGreen", LazyIconColorLensGreen],
["IconColorLensGrey", LazyIconColorLensGrey],
["IconColorLila", LazyIconColorLila],
["IconColorOrange", LazyIconColorOrange],
["IconColorPink", LazyIconColorPink],
["IconColorRosa", LazyIconColorRosa],
["IconColorRot", LazyIconColorRot],
["IconColorSchwarz", LazyIconColorSchwarz],
["IconColorSilber", LazyIconColorSilber],
["IconColorSilberfarben", LazyIconColorSilberfarben],
["IconColorTransparent", LazyIconColorTransparent],
["IconColorViolett", LazyIconColorViolett],
["IconColorWeiss", LazyIconColorWeiss],
["IconFaceShapeEckig", LazyIconFaceShapeEckig],
["IconFaceShapeHerz", LazyIconFaceShapeHerz],
["IconFaceShapeOval", LazyIconFaceShapeOval],
["IconFaceShapeRund", LazyIconFaceShapeRund],
["IconFaceShapeTrapez", LazyIconFaceShapeTrapez],
["IconFielmannAbo", LazyIconFielmannAbo],
["IconFielmannArrowDoubleLeft", LazyIconFielmannArrowDoubleLeft],
["IconFielmannArrowDoubleRight", LazyIconFielmannArrowDoubleRight],
["IconFielmannArrowDown", LazyIconFielmannArrowDown],
["IconFielmannArrowLeft", LazyIconFielmannArrowLeft],
["IconFielmannArrowRight", LazyIconFielmannArrowRight],
["IconFielmannArrowUp", LazyIconFielmannArrowUp],
["IconFielmannBook", LazyIconFielmannBook],
["IconFielmannBox", LazyIconFielmannBox],
["IconFielmannBrokenHeart", LazyIconFielmannBrokenHeart],
["IconFielmannBurger", LazyIconFielmannBurger],
["IconFielmannCalendar", LazyIconFielmannCalendar],
["IconFielmannCameraBordered", LazyIconFielmannCameraBordered],
["IconFielmannCancel", LazyIconFielmannCancel],
["IconFielmannCart", LazyIconFielmannCart],
["IconFielmannCheck", LazyIconFielmannCheck],
["IconFielmannCheckCircle", LazyIconFielmannCheckCircle],
["IconFielmannCheckHalfcircle", LazyIconFielmannCheckHalfcircle],
["IconFielmannChevronDown", LazyIconFielmannChevronDown],
["IconFielmannChevronLeft", LazyIconFielmannChevronLeft],
["IconFielmannChevronRight", LazyIconFielmannChevronRight],
["IconFielmannChevronUp", LazyIconFielmannChevronUp],
["IconFielmannCircleCross", LazyIconFielmannCircleCross],
["IconFielmannClipboard", LazyIconFielmannClipboard],
["IconFielmannClock", LazyIconFielmannClock],
["IconFielmannClose", LazyIconFielmannClose],
["IconFielmannCompass", LazyIconFielmannCompass],
["IconFielmannComputer", LazyIconFielmannComputer],
["IconFielmannContactLens", LazyIconFielmannContactLens],
["IconFielmannDelivery", LazyIconFielmannDelivery],
["IconFielmannDelivery2", LazyIconFielmannDelivery2],
["IconFielmannDownload", LazyIconFielmannDownload],
["IconFielmannDuration", LazyIconFielmannDuration],
["IconFielmannEdit", LazyIconFielmannEdit],
["IconFielmannEmojiSad", LazyIconFielmannEmojiSad],
["IconFielmannEye", LazyIconFielmannEye],
["IconFielmannEyeTest", LazyIconFielmannEyeTest],
["IconFielmannEyeTestMultifocal", LazyIconFielmannEyeTestMultifocal],
["IconFielmannFavoriteActive", LazyIconFielmannFavoriteActive],
["IconFielmannFavoriteInactive", LazyIconFielmannFavoriteInactive],
["IconFielmannFilter", LazyIconFielmannFilter],
["IconFielmannFrame", LazyIconFielmannFrame],
["IconFielmannFrameVarifocals", LazyIconFielmannFrameVarifocals],
["IconFielmannGift", LazyIconFielmannGift],
["IconFielmannGlass", LazyIconFielmannGlass],
["IconFielmannGlasses", LazyIconFielmannGlasses],
["IconFielmannGlassesSimilar", LazyIconFielmannGlassesSimilar],
["IconFielmannGlassesSingleVision", LazyIconFielmannGlassesSingleVision],
["IconFielmannGlassesWidth", LazyIconFielmannGlassesWidth],
["IconFielmannHearingAid", LazyIconFielmannHearingAid],
["IconFielmannHistory", LazyIconFielmannHistory],
["IconFielmannHome", LazyIconFielmannHome],
["IconFielmannInfoCircle", LazyIconFielmannInfoCircle],
["IconFielmannInvoice", LazyIconFielmannInvoice],
["IconFielmannLock", LazyIconFielmannLock],
["IconFielmannLogin", LazyIconFielmannLogin],
["IconFielmannLogo", LazyIconFielmannLogo],
["IconFielmannLogoCZ", LazyIconFielmannLogoCZ],
["IconFielmannLogoPL", LazyIconFielmannLogoPL],
["IconFielmannLogout", LazyIconFielmannLogout],
["IconFielmannMail", LazyIconFielmannMail],
["IconFielmannMinus", LazyIconFielmannMinus],
["IconFielmannMore", LazyIconFielmannMore],
["IconFielmannMoreVertical", LazyIconFielmannMoreVertical],
["IconFielmannNavigate", LazyIconFielmannNavigate],
["IconFielmannNotification", LazyIconFielmannNotification],
["IconFielmannOpenInWindow", LazyIconFielmannOpenInWindow],
["IconFielmannPause", LazyIconFielmannPause],
["IconFielmannPencil", LazyIconFielmannPencil],
["IconFielmannPhone", LazyIconFielmannPhone],
["IconFielmannPin", LazyIconFielmannPin],
["IconFielmannPlay", LazyIconFielmannPlay],
["IconFielmannPlus", LazyIconFielmannPlus],
["IconFielmannQuestionBubble", LazyIconFielmannQuestionBubble],
["IconFielmannReload", LazyIconFielmannReload],
["IconFielmannReloadDouble", LazyIconFielmannReloadDouble],
["IconFielmannReturn", LazyIconFielmannReturn],
["IconFielmannReturnAlt", LazyIconFielmannReturnAlt],
["IconFielmannReturnOrder", LazyIconFielmannReturnOrder],
["IconFielmannScreenshot", LazyIconFielmannScreenshot],
["IconFielmannSearch", LazyIconFielmannSearch],
["IconFielmannSettings", LazyIconFielmannSettings],
["IconFielmannShoppingBag", LazyIconFielmannShoppingBag],
["IconFielmannSoundHigh", LazyIconFielmannSoundHigh],
["IconFielmannSoundOff", LazyIconFielmannSoundOff],
["IconFielmannSpeechBubbles", LazyIconFielmannSpeechBubbles],
["IconFielmannStore", LazyIconFielmannStore],
["IconFielmannSunglasses", LazyIconFielmannSunglasses],
["IconFielmannTools", LazyIconFielmannTools],
["IconFielmannTrash", LazyIconFielmannTrash],
["IconFielmannUpdown", LazyIconFielmannUpdown],
["IconFielmannUser", LazyIconFielmannUser],
["IconFielmannUserCircle", LazyIconFielmannUserCircle],
["IconFielmannUserVerified", LazyIconFielmannUserVerified],
["IconFielmannWallet", LazyIconFielmannWallet],
["IconFielmannWarning", LazyIconFielmannWarning],
["IconFielmannWarningHexagon", LazyIconFielmannWarningHexagon],
["IconFielmannWebcam", LazyIconFielmannWebcam],
["IconFielmannZoomIn", LazyIconFielmannZoomIn],
["IconFrameShapeAchteckig", LazyIconFrameShapeAchteckig],
["IconFrameShapeBrowline", LazyIconFrameShapeBrowline],
["IconFrameShapeButterfly", LazyIconFrameShapeButterfly],
["IconFrameShapeCateye", LazyIconFrameShapeCateye],
["IconFrameShapeEckig", LazyIconFrameShapeEckig],
["IconFrameShapeHalb", LazyIconFrameShapeHalb],
["IconFrameShapeKaree", LazyIconFrameShapeKaree],
["IconFrameShapeMehreckig", LazyIconFrameShapeMehreckig],
["IconFrameShapeMonoscheibe", LazyIconFrameShapeMonoscheibe],
["IconFrameShapeOval", LazyIconFrameShapeOval],
["IconFrameShapePanto", LazyIconFrameShapePanto],
["IconFrameShapePilot", LazyIconFrameShapePilot],
["IconFrameShapeQuadratisch", LazyIconFrameShapeQuadratisch],
["IconFrameShapeRaute", LazyIconFrameShapeRaute],
["IconFrameShapeRechteckig", LazyIconFrameShapeRechteckig],
["IconFrameShapeRund", LazyIconFrameShapeRund],
["IconFrameShapeSchmal", LazyIconFrameShapeSchmal],
["IconFrameShapeSonstige", LazyIconFrameShapeSonstige],
["IconHeadWidthL", LazyIconHeadWidthL],
["IconHeadWidthM", LazyIconHeadWidthM],
["IconHeadWidthS", LazyIconHeadWidthS],
["IconLensqualityCheck", LazyIconLensqualityCheck],
["IconLensqualityShield", LazyIconLensqualityShield],
["IconLensqualitySun", LazyIconLensqualitySun],
["IconPaymentBlik", LazyIconPaymentBlik],
["IconPaymentCashOnDelivery", LazyIconPaymentCashOnDelivery],
["IconPaymentCreditcard", LazyIconPaymentCreditcard],
["IconPaymentDinersclub", LazyIconPaymentDinersclub],
["IconPaymentDiscover", LazyIconPaymentDiscover],
["IconPaymentKlarna", LazyIconPaymentKlarna],
["IconPaymentLastschrift", LazyIconPaymentLastschrift],
["IconPaymentMastercard", LazyIconPaymentMastercard],
["IconPaymentP24", LazyIconPaymentP24],
["IconPaymentPaypalBw", LazyIconPaymentPaypalBw],
["IconPaymentPaypal", LazyIconPaymentPaypal],
["IconPaymentRatepay", LazyIconPaymentRatepay],
["IconPaymentRechnung", LazyIconPaymentRechnung],
["IconPaymentSofort", LazyIconPaymentSofort],
["IconPaymentTwint", LazyIconPaymentTwint],
["IconPaymentVisa", LazyIconPaymentVisa],
["IconRimTypeGerillt", LazyIconRimTypeGerillt],
["IconRimTypeHalbrand", LazyIconRimTypeHalbrand],
["IconRimTypeNylor", LazyIconRimTypeNylor],
["IconRimTypeRandlos", LazyIconRimTypeRandlos],
["IconRimTypeVollrand", LazyIconRimTypeVollrand],
["IconSocialFacebook", LazyIconSocialFacebook],
["IconSocialInstagram", LazyIconSocialInstagram],
["IconSocialPinterest", LazyIconSocialPinterest],
["IconSocialYoutube", LazyIconSocialYoutube],
["IconVtoVerfugbar", LazyIconVtoVerfugbar],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
